module.exports = __webpack_public_path__ + "static/media/client-15.b9f7d66b.jpg";